import { Navigate } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import AuthService from '@commonClient2/services/auth';
import Unauthorized from '@commonClient2/components/Unauthorized';

export const goToHrisUrl = async () => {
    const hrisUrl = sessionStorage.getItem('hrisUrl') || '';
    setTimeout(() => { window.location.href = hrisUrl; }, 5000);
};

const PrivateRoute = ({ children, loginPage, redirectUrl, requiredLicense }) => {
    const isLoggedIn = AuthService.isLoggedIn();
    const isLicenseValid = !requiredLicense || (requiredLicense && AuthService.validateLicense(requiredLicense));

    // User is logged in but doesn't have the required license - show Unauthorized page
    if (isLoggedIn && !isLicenseValid) {
        return <Unauthorized />;
    }

    // User is not logged in - redirect to login or HRIS
    if (!isLoggedIn) {
        toastr.error('Logging in', 'You are not logged in');
        if (redirectUrl) {
            window.location.href = redirectUrl;
            return <></>;
        }

        if (process.env.NODE_ENV === 'production') {
            goToHrisUrl();
            return <></>;
        }
        return <Navigate to={loginPage} />;
    }

    return children;
};

export default PrivateRoute;
